module.exports = __webpack_public_path__ + "media/dashboard/organizations-802d233c.svg";